export default __webpack_public_path__ + "static/media/pageWeb.ffe51e53.svg";